// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3LGjD","inputWrap":"CustomTip_inputWrap__pUPu_"};